<template>
  <div class="px-4" style="overflow: auto; max-height: 100%;">
    <div class="d-flex align-items-center" style="margin-bottom: 8px;">
      <el-button v-if="type !== 'select'" class="is-round" style="margin-right: 8px;" @click="typeChange('select')">
        <BaseIcon name="arrow-left" />
        <span style="margin-left: 4px;">返回項目首頁</span>
      </el-button>
      <div>
        <h4 v-if="type === 'select'">選擇項目</h4>
        <h4 v-if="type === 'purchase'">商品列表</h4>
        <h4 v-if="type === 'order'">結帳金額</h4>
      </div>
    </div>
    <div v-if="type === 'select'" class="d-flex">
      <div :class="$style.contentText" @click="typeChange('purchase')">
        <BaseIcon name="store" class="fs-1 mb-3 flex-column" />
        <span>商品購買</span>
      </div>
      <!-- 總訂單先不顯示 -->
      <!-- <div v-if="memberInfo.id" :class="$style.contentText" @click="typeChange('order')">
        <BaseIcon name="clipboard-list" class="fs-1 mb-3 flex-column" />
        <span>目前總訂單</span>
      </div> -->
    </div>
    <div>
      <div v-if="selectStore && type !== 'select' && categoryTitle" class="d-flex justify-content-between mb-4" :class="$style.subTitleDisplay">
        <div class="d-flex align-items-center">
          <el-button size="small" :class="[$style.backBtn, $style.btnNoStyle]" @click="backTopLevel">
            <i class="fa fa-angle-left fa-icon" aria-hidden="true"></i>
          </el-button>
          <h4>{{ categoryTitle }}</h4>
        </div>
      </div>
      <div v-if="type === 'purchase' || type === 'product'">
        <el-select v-model="selectStore" placeholder="請選擇分店" class="mb-2" @change="updateProductId">
          <el-option v-for="item in storesList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-input type="string" v-model="search" placeholder="搜尋商品名稱">
          <el-icon slot="suffix" name="search"></el-icon>
        </el-input>
      </div>
      <div v-if="selectStore && type === 'purchase'" :class="$style.container" class="mt-4">
        <div v-for="(category, index) in currentList" :key="index" :class="$style.contentText" @click="goNextCategory(category)">
          {{ category.title }}
        </div>
      </div>
      <el-row v-if="type === 'product'">
        <el-col :span="8" v-for="(item, index) in productList" :key="index">
          <div :class="$style.imgAndP" @click="selectProduct(index)">
            <img v-if="item.image" :src="item.image" />
            <img v-else :src="require(`@assets/images/icons/face-cream.svg`)" />
            <div>
              <p class="title">{{ item.title }}</p>
              <p class="subTitle" style="font-size: 12px;">{{ item.petCategoryTitle }}</p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 客戶購買清單列表 -->
    <el-dialog title="選擇款式" class="purchase-dialog" :visible.sync="dialogVisible" @close="closeDialog" width="50%" center :top="'0'" :append-to-body="true">
      <p class="text-center">{{ selectProductData.title }}</p>
      <div v-for="(spec, index) in selectProductData.spec" :key="spec.alias">
        <p>{{ spec.title }}</p>
        <el-button plain round v-for="value in spec.values" :key="value.alias" :type="value.type" @click="addBtnType(value, index)">
          {{ value.title }}
        </el-button>
      </div>
      <div v-if="specReorganize === ''" class="mb-4"></div>
      <p v-if="specReorganize !== ''">數量</p>
      <el-row v-if="specReorganize !== ''" :gutter="10" class="mb-3">
        <el-col :span="8"><el-button type="primary" plain round icon="el-icon-minus" class="w-100" :disabled="qty <= 1" @click="purchaseNumUpdate('minus')"></el-button></el-col>
        <el-col :span="8"><el-input type="number" v-model="qty" @input="handleInput()" :disabled="currentInventory === 0"></el-input></el-col>
        <el-col :span="8"><el-button type="primary" plain round icon="el-icon-plus" class="w-100" :disabled="qty >= currentInventory" @click="purchaseNumUpdate('plus')"></el-button></el-col>
      </el-row>
      <span slot="footer">
        <el-button type="primary" class="w-100" round @click="addCart" :disabled="currentInventory <= 0">加入訂單</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import lazyLoadComponent from '@router/lazyload-component'
import cloneDeep from 'lodash/cloneDeep'
import { mapGetters } from 'vuex'

export default {
  props: {
    memberInfo: {
      type: Object,
      default: () => ({}),
    },
    selectProductId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectStore: '', // 當前分店
      storesList: [], // 分店清單
      search: '', // 搜尋字串
      categoryList: [], // 商品分類清單
      currentList: [], // 當前商品分類
      productList: [], // 全部商品列表
      selectProductData: [], // 選擇的商品
      qty: 1,
      // 商品選擇狀態 select為選擇介面 purchase為購買介面 product為顯示商品清單 order為訂單介面
      type: 'select',
      dialogVisible: false,
      currentInventory: 0,
    }
  },
  computed: {
    categoryTitle() {
      if (this.currentList.length && this.currentList[0].level !== 0) {
        return this.currentList[0].categoryTitle
      }
      return ''
    },
    // 組成商品spec標籤並查找庫存
    specReorganize() {
      if (Object.keys(this.selectProductData).length) {
        const arr = []
        const result = this.selectProductData.spec.every((title) => {
          return title.values.some((value) => value.type === 'primary')
        })
        if (result) {
          this.selectProductData.spec.forEach((title) => {
            const obj = title.values.filter((value) => value.type === 'primary')
            const str = title.title + title.alias + ':' + obj[0].title + obj[0].alias
            arr.push(str)
          })
          const spec = arr.join()
          const data = this.selectProductData.petSizes.filter((item) => item.spec_tag === spec && item.productId === this.selectStore)
          this.currentInventory = data.length ? data[0].inventory : 0
          if (this.currentInventory === 0) {
            this.$message({
              type: 'warning',
              message: '該商品目前無庫存',
            })
            return spec
          }
          return spec
        }
        this.currentInventory = 0
        return ''
      }
      this.currentInventory = 0
      return ''
    },
    ...mapGetters('cart', ['cartList']),
  },
  watch: {
    // 回到項目首頁
    type(nvl) {
      if (nvl === 'select') {
        this.currentList = this.categoryList
      }
    },
    async search(word) {
      if (word) {
        this.type = 'product'
        await this.getProductList()
        this.productList = this.productList.filter((item) => item.title.includes(word))
      } else {
        this.type = 'purchase'
      }
    },
  },
  methods: {
    // 變更table狀態
    async typeChange(type) {
      const guestId = this.$store.state.merchant.cached.guest
      if (!this.memberInfo.id && this.type === 'select') {
        this.$emit('enter-visitor-mode', guestId)
      }
      if (type === 'order') {
        const memberId = this.memberInfo.id ? this.memberInfo.id : guestId
        this.$emit('enter-order-detail', memberId)
      }
      this.type = type
    },
    // 取得商品類別
    async getCategoryList() {
      this.categoryList = await this.$store.dispatch('product/fetchServiceCategoryForLeaf', {
        type: 'goods',
        onlyLeaf: 0,
      })
      this.currentList = this.categoryList
    },
    // 取得分店列表
    async fetchStoresList() {
      const { items } = await this.$store.dispatch('product/fetchList', {
        limit: 10000,
        page: 1,
        paginate: 0,
      })
      this.storesList = items
    },
    // 商品類別選擇
    goNextCategory(category) {
      if (this.isLastCategory(category)) {
        // 如果是最後一層，就來這邊找商品清單
        this.getProductList(category.id)
        this.type = 'product'
      } else {
        this.currentList = category.children
      }
    },
    // 確認是否尚有子類別
    isLastCategory(category) {
      return category.children.length === 0
    },
    // 回到標籤最上層
    backTopLevel() {
      this.type = 'purchase'
      this.currentList = this.categoryList
    },
    // 取得商品清單
    async getProductList(id) {
      try {
        let res = await this.$store.dispatch('product/fetchNormalServiceData', {
          types: ['goods'],
          petCategoryId: id,
        })
        res.items.forEach((item) => {
          item.petSizes.forEach((petItem) => {
            this.$set(petItem, 'petCategory', item.petCategoryTitle)
            this.$set(petItem, 'serviceTitle', item.title)
          })
        })
        this.productList = res.items
      } catch (error) {
        console.error(error.message)
      }
    },
    // 使用者選擇商品
    selectProduct(index) {
      this.selectProductData = cloneDeep(this.productList[index])
      this.dialogVisible = true
    },
    // 按鈕點擊效果
    addBtnType(value, index) {
      this.selectProductData.spec[index].values.forEach((item) => this.$set(item, 'type', 'default'))
      this.$set(value, 'type', 'primary')
    },
    // 購買數量加減
    purchaseNumUpdate(type) {
      this.qty = type === 'plus' ? parseInt(this.qty) + 1 : parseInt(this.qty) - 1
    },
    // input防呆
    handleInput() {
      if (this.qty < 1) {
        this.qty = 1
      }
      if (this.qty.toString().includes('.')) {
        this.qty = Math.floor(this.qty)
      }
      if (this.qty > this.currentInventory) {
        this.qty = this.currentInventory
      }
    },
    // 加入購買清單
    addCart() {
      if (this.specReorganize === '') {
        this.$message({
          type: 'error',
          message: '請選擇規格',
        })
        return
      }
      const product = this.selectProductData.petSizes.filter((item) => item.spec_tag === this.specReorganize && item.productId === this.selectStore)
      product[0].qty = Number(this.qty)
      this.qty = 1
      this.$store.commit('cart/UPDATE_CART', product[0])
      this.$emit('clone-cart')
      this.dialogVisible = false
    },
    // 將分店資料傳回父元件
    updateProductId() {
      this.$emit('update-product-id', this.selectStore)
    },
    closeDialog() {
      this.currentInventory = 0
      this.dialogVisible = false
    },
  },
  created() {
    if (this.memberInfo.id) {
      this.type = this.cartList.length ? 'purchase' : 'select'
    }
    if(this.selectProductId) {
      this.selectStore = this.selectProductId
    }
  },
  async mounted() {
    await this.getCategoryList()
    await this.fetchStoresList()
    if (this.cartList.length) {
      this.selectStore = this.cartList[0].productId
    }
  },
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
}

.contentText {
  width: 45%;
  height: 175px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  border: 1px solid $color-text-placeholder;
  margin-right: 13px;
  margin-bottom: 13px;
  color: $color-primary;
  flex-shrink: 0;
  border-radius: $border-radius;

  &:hover {
    cursor: pointer;
  }
}

.contentImgItem {
  display: flex;
  max-width: 33%;

  > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: #ffffff;

    p {
      margin-top: 0;
      margin-bottom: 0;
    }

    :global {
      .title {
        color: $color-secondary;
        font-size: 14px;
        margin-bottom: 7px;
        margin-top: 10px;
      }
    }
  }
}

.imgAndP {
  :global {
    margin: 5px;

    img {
      width: 100%;
      height: 90px;
      display:block
    }

    div {
      width: 100%;
      height: 80px;
      padding: 8px 8px 8px;
      background-color: #ffffff;
    }

    .title {
      margin-top: 0;
    }
  }
}

.subTitleDisplay {
  display: flex;
  flex-direction: row;
  align-items: center;

  > span {
    margin-right: 20px;
  }
}

.btnNoStyle {
  border: none;
  background-color: transparent;

  &:hover,
  &:focus {
    background-color: transparent;
  }
}

.backBtn {
  border: none;

  :global {
    i {
      font-size: 15px;
    }
  }
}
</style>
